import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

interface StyledDivProps {
  children?: ReactNode;
  style?: CSSProperties;
}

export const ModalStyle = styled.div<StyledDivProps>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  background-color: #e4e4e4;
  border-radius: 0;
  overflow: hidden;
  min-width: 320px;
  margin: 0px 10px;

  &.ReactModal__Content {
    opacity: 0;
    transform: translateY(-100px);
    transition: all 300ms ease-in-out;
  }

  &.ReactModal__Content--after-open {
    opacity: 1;
    transform: translateX(0px);
  }

  &.ReactModal__Content--before-close {
    opacity: 0;
    transform: translateY(-100px);
  }

  &:focus-visible {
    outline: none;
  }
`;

export const OverlayStyle = styled.div<StyledDivProps>`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3500;
  background: rgba(0, 0, 0, 0.5);

  &.ReactModal__Overlay {
    opacity: 0;
    transition: opacity 300ms ease-in-out;
  }

  &.ReactModal__Overlay--after-open {
    opacity: 1;
  }

  &.ReactModal__Overlay--before-close {
    opacity: 0;
  }
`;

export const ModalDialogWrapper = styled.div<StyledDivProps>`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  position: relative;
  max-height: 95vh;
`;
